export const COGNITO_IDENTITY_POOL_ID = "ap-northeast-1:d8c75881-bf30-438e-908c-42fb87cfaf6f"
export const COGNITO_USER_POOL_ID = "ap-northeast-1_SBK17xBhW"
export const COGNITO_WEB_CLIENT_ID = "5e0at86phdkhdou88m1lj3aali"
export const API_GATEWAY_ENDPOINT_INCLUDE_STAGE = "https://maayt67my6.execute-api.ap-northeast-1.amazonaws.com/prd2"